// import axios from "axios";
import * as d3 from "d3";
import {inrFormatterV2, multiColumnSort, resetFilterFlagTabalebarChart, wrapsword} from '../functions'

import CommonFn from '../index'

window.toggleJourneyInline = function (el) {
    const pre = el.parentElement.querySelector(".journey-json");

    if (pre.style.display === "none") {
        if (!pre.textContent) {
            let raw = pre.getAttribute("data-json");
            let parsed;

            try {
                // ✅ Handle both STRING JSON and OBJECT JSON
                parsed = typeof raw === "string" ? JSON.parse(raw) : raw;
            } catch (e) {
                parsed = raw;
            }

            // ✅ Pretty print → each object on new lines
            pre.textContent = JSON.stringify(parsed, null, 2);
        }

        pre.style.display = "block";
        el.textContent = "📂 Hide";
    } else {
        pre.style.display = "none";
        el.textContent = "📄 View";
    }
};

export default function (chart, divId,vizName,resData,paramName,checkbox, gridflag,showValuesFlag,resetfilter) {
    /*Imp Note:
    1. Graph col must be end with '#' (like: DevLastWkRev%#).
    2. which metric will display the graph same number to be put the graph also.
    ie. if we want to print the graph metric3, so graph also be graph3.
*/
    // var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName;
    // console.log("table bar", url)
    // axios.post(url, filterParam).then(res => {
        let data = resData;
        console.log("resetfilter",paramName,checkbox, gridflag,showValuesFlag,resetfilter)
        // Filter null and undefined values from the data
        //let filteredData = Object.entries(data[0]).reduce((a,[k,v]) => (v == null ? a: (a[k]=v, a) ), {})

        // Setup the scale for the values for display, use abs max as max value
        var titleMap = chart.reportHeaderColumnDp;
        console.log("titleMap:", titleMap)
        // get the keys from filtered data which filtered null, undefined columns

        var dataTitlesOrg = d3.values(titleMap)
        var dataTitles = dataTitlesOrg.filter(function (item) {
            return !item.startsWith('graph')
        })

    const uniqueValues = data.map(item => item.dim2_name);

    console.log("dataTitles",uniqueValues)
        /* to make soting fun work properly based on data dim names,
        create a title mapping between dp names and backend dim names */
        var titles = d3.keys(titleMap)
       // var sortAscending = true;
        var view = chart.vizSpecific6
        console.log("reportHeaderColumnDpWordwrap",chart.reportHeaderColumnDpWordwrap);
        const jsonData=chart.reportHeaderColumnDpWordwrap;
        const vebdorname=jsonData.wordwrap['table heading'];
        const vendoraddres=jsonData.wordwrap['table data'];
        console.log("vebdorname",vebdorname);
        console.log("vendoraddres",vendoraddres);
        //Table reports ploting to times need to revisit
        d3.select(divId).select("table").remove();

    d3.select(divId).select("div").remove();

    var table = d3.select(divId).append("table").style("width", "100%");
    let sortState = []; // Array to track sort columns and directions

        // Create table header
        var headers = table.append('thead')
            .append('tr')
            .selectAll('th')
            .data(titles)
            .enter()
            .append('th')
            .attr("class", 'tbc-header')
            .style("background", "#333")
            .style("padding-top", "5px") // Adjust the top padding as needed
            .style("padding-bottom", "5px")
            .text(function (d) {
                return wrapsword(d,vebdorname)
            })
            .style("text-align", "center")
            .style("color", "#fff")
            .style("white-space", "pre")
            .style("line-height", "1")
            .style("width", '0px')
            .on('click', function(d) {
                // Get the actual data column name
                let dataColumn = titleMap[d];
                if (d.endsWith('#')) {
                    dataColumn = titleMap[d].replace('graph', 'metric');
                }

                // Check if this column is already in sort state
                const existingIndex = sortState.findIndex(item => item.column === dataColumn);

                if (existingIndex >= 0) {
                    // Column is already being sorted - check its current state
                    if (sortState[existingIndex].direction === 'asc') {
                        // Currently ascending - change to descending
                        sortState[existingIndex].direction = 'desc';
                    } else {
                        // Currently descending - remove from sort
                        sortState.splice(existingIndex, 1);
                    }
                } else {
                    // Column not being sorted - add with ascending sort
                    sortState.push({ column: dataColumn, direction: 'asc' });
                }

                // Apply the sort
                if (sortState.length > 0) {
                    const sortColumns = sortState.map(item => item.column);
                    const sortDirections = sortState.map(item => item.direction);
                    tr.sort(multiColumnSort(sortColumns, sortDirections));
                } else {
                    // No sorting - return to original order
                    tr.sort((a, b) => a.__originalIndex - b.__originalIndex);
                }

                // Update header classes to show sort state
                headers.attr('class', 'tbc-header');

                if (sortState.length === 0) {
                    headers.select('.sort-order').remove();
                } else {
                    sortState.forEach((sortItem, index) => {
                        const header = headers.filter(h => {
                            const col = titleMap[h];
                            return col === sortItem.column ||
                                (col.startsWith('graph') && col.replace('graph', 'metric') === sortItem.column);
                        });

                        // Set class based on direction
                        const cls = sortItem.direction === 'asc' ? 'tbc-aes' : 'tbc-des';
                        header.attr('class', cls);

                        // Remove old indicator
                        header.select('.sort-order').remove();
                        if (cls !== 'tbc-header') {
                            header.append('span')
                                .attr('class', 'sort-order')
                                .style('font-size', '0.7em')
                                .style('margin-left', '5px')
                                .text(index + 1);
                        }
                    });
                }
            })

    // Create a table with rows and bind a data row to each table row
        var tr = table.selectAll('tr.g').data(data).enter().append('tr');
        //selectAll selects the already available tr element so it skips the data first row
        //https://stackoverflow.com/questions/19182775/d3-data-skipping-the-first-row-of-data

        tr.selectAll('td')
            .data(function (d,i) {
                return dataTitles.map(function (k) {
                    return {'value': d[k], 'name': k,'rowIndex': i};
                });
            })
            .enter()
            .append('td')
            .attr("class", "reptd")
            .attr('data-th', (d) => {
                return d.name;
            })
            // .text((d) =>{ return inrFormatter(d.value) })
            .html((d) => {
                if (d.name.startsWith('metric')) {
                    return inrFormatterV2(d.value,chart.data.menuId);
                } else {
                    if (d.name === 'hyperlink') {
                        const isMobile = window.innerWidth <= 767; // Common mobile breakpoint
                        return `<a ${isMobile ? '' : 'target="_blank"'} href="${d.value}">${view}</a>`;
                    }else if(d.name ==='menulink'){
                        const isMobile = window.innerWidth <= 767; // Common mobile breakpoint
                        return `<a ${isMobile ? '' : 'target="_blank"'} href="${d.value}">${uniqueValues[d.rowIndex]}</a>`;
                    }
                    else if (d.name === 'jsonView') {
                        if (!d.value) return '';

                        return `
  <div class="journey-wrapper" style="padding:0;margin:0">
    <span
      style="cursor:pointer;color:#4da3ff;font-weight:600;display:inline-block;margin-bottom:4px"
      onclick="toggleJourneyInline(this)">📄 View</span>

    <pre
      class="journey-json"
      style="
        display:none;
        margin:0;
        padding:6px;
        background:#ede9e9;
        color:#000000;
        max-height:280px;
        overflow:auto;
        font-size:12px;
        border-radius:4px;
        line-height:1.3;
      "
      data-json='${d.value}'
    ></pre>
  </div>
`;
                    }
                    else {
                        return d.value;
                    }
                }
            })
            .style("text-align", (d) => {
                const isMetric = d.name.startsWith('metric');
                const isSrcStart = d.name.startsWith('src');
                const isIdEnd = d.name.endsWith('id');
                return (isMetric || isSrcStart || isIdEnd) ? 'right' : 'left'
            })
            .style("color", (d) => {
                const isMetric = d.name.startsWith('metric');
                const isSrcStart = d.name.startsWith('src');
                const isIdEnd = d.name.endsWith('id');
                if (isMetric || isSrcStart || isIdEnd) {
                    return d.value >= 0 ? 'steelblue' : 'brown'
                }
            })
            .style("white-space", (d) => {
                return d.name === 'jsonView' ? 'normal' : 'pre';
            })
            .style("line-height", "1.2")
            .style("width",'0px')


    for (var key in titleMap) {
        if (titleMap[key].startsWith('graph')) {
            var val = titleMap[key];
            var valMetric = val.replace('graph', 'metric');

            // Append a table cell (td) for the graph
            var graph = tr.append("td")
                .attr("class", "tbc-" + val)
                .attr("width", 2 * chart.width);

            // Append container div for negative and positive bars
            var container = graph.append("div")
                .attr("class", "container")
                .style("width", 2 * chart.width)
                .style("display", "flex")
                .style("height", "10px");  // Adjust the height of the graph bars

            // Negative graph part (left side)
            container.append("div")
                .attr("class", "negative" + val.replace('graph', ''))
                .style("background-color", chart.vizSpecific5);

            // Positive graph part (right side)
            container.append("div")
                .attr("class", "positive" + val.replace('graph', ''))
                .style("background-color", chart.vizSpecific4);

            // Calculate the scale for the graph
            var x1Scale = d3.scaleLinear()
                .domain([0, d3.max(data, (d) => Math.abs(d[valMetric]))])
                .range([0, 100]);  // Range from 0% to 100%

            // Update negative graph part
            tr.select("div.negative" + val.replace('graph', ''))
                .style("width", "0%")
                .transition()
                .duration(500)
                .style("float", "right")
                .style("width", (d) => {
                    return d[valMetric] > 0 ? "0%" : x1Scale(Math.abs(d[valMetric])) + "%";
                });

            // Update positive graph part
            tr.select("div.positive" + val.replace('graph', ''))
                .style("width", "0%")
                .transition()
                .duration(500)
                .style("float", "right")
                .style("width", (d) => {
                    return d[valMetric] > 0 ? x1Scale(d[valMetric]) + "%" : "0%";
                });
        }
    }
    resetFilterFlagTabalebarChart(false)
    CommonFn.renderChartCompare(chart, divId,vizName,resData,paramName,checkbox, gridflag,showValuesFlag,resetfilter)
    // })
}
